import {
  DollarOutlined,
  FileTextOutlined,
  LockOutlined,
  TeamOutlined,
  UnlockOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Spin } from "antd";
import { useEffect, useState } from "react";
import { getUserName } from "../../utils/getUserName";
import s from "./TodayReport.module.css";

export default function TodayReport({ data, loading }) {
  const name = localStorage.getItem("name");
  const [cards, setCards] = useState([
    {
      key: "me",
      color: "#FCE9F0",
      iconBg: "#F6D5E0",
      icon: <UserOutlined />,
      title: `Hi, ${getUserName() || "N/A"} `,
      subtitle: "My Details",
      link: "ERP Dashboard",
    },
    {
      key: "checkins",
      color: "#FEF1DC",
      iconBg: "#FDE7C6",
      icon: <FileTextOutlined />,
      title: "0",
      subtitle: "Check-ins",
      link: "Today's ",
    },
    {
      key: "checkouts",
      color: "#E6F8EB",
      iconBg: "#D6F2DE",
      icon: <DollarOutlined />,
      title: "0",
      subtitle: "Check-outs",
      link: "Today's",
    },
    {
      key: "total-guests",
      color: "#F0E9FF",
      iconBg: "#E7DFFF",
      icon: <TeamOutlined />,
      title: "0",
      subtitle: "Guests",
      link: "Total ",
    },
    {
      key: "available-rooms",
      color: "#FEF1DC",
      iconBg: "#FDE7C6",
      icon: <UnlockOutlined />,
      title: "0",
      subtitle: "Available Rooms",
      link: "Total ",
    },
    {
      key: "occupied-rooms",
      color: "#DDEEFF",
      iconBg: "#D2E6FD",
      icon: <LockOutlined />,
      title: "0",
      subtitle: "Occupied Rooms",
      link: "Total",
    },
  ]);

  const { bookings, rooms, guests } = data || {};
  const isBookingsLoading = loading?.bookings;
  const isRoomsLoading = loading?.rooms;
  const isGuestsLoading = loading?.guests;

  useEffect(() => {
    fetchAllData();
  }, [bookings, rooms, guests, loading.bookings]);

  const fetchAllData = async () => {
    try {
      const today = new Date().toDateString();

      const checkInsToday =
        bookings?.filter(
          (booking) =>
            new Date(booking.check_in).toDateString() === today &&
            booking.status === "confirmed",
        ).length || 0;

      const checkOutsToday =
        bookings?.filter(
          (booking) =>
            new Date(booking.check_out).toDateString() === today &&
            booking.status === "check_out",
        ).length || 0;

      const totalRooms = rooms?.length;
      const occupiedRooms = rooms?.filter(
        (room) => room.status === "occupied",
      ).length;
      const availableRooms = totalRooms - occupiedRooms;

      const totalGuests = guests?.length;

      setCards([
        {
          key: "me",
          color: "#FCE9F0",
          iconBg: "#F6D5E0",
          icon: <UserOutlined />,
          title: `Hi, ${name || "N/A"} `,
          subtitle: "My Details",
          link: "ERP Dashboard",
        },
        {
          key: "checkins",
          color: "#FEF1DC",
          iconBg: "#FDE7C6",
          icon: <FileTextOutlined />,
          title: isBookingsLoading ? (
            <Spin size="small" />
          ) : (
            checkInsToday.toString()
          ),
          subtitle: "Check-ins",
          link: "Today's ",
        },
        {
          key: "checkouts",
          color: "#E6F8EB",
          iconBg: "#D6F2DE",
          icon: <DollarOutlined />,
          title: isBookingsLoading ? (
            <Spin size="small" />
          ) : (
            checkOutsToday.toString()
          ),
          subtitle: "Check-outs",
          link: "Today's",
        },
        {
          key: "total-guests",
          color: "#F0E9FF",
          iconBg: "#E7DFFF",
          icon: <TeamOutlined />,
          title: isGuestsLoading ? (
            <Spin size="small" />
          ) : (
            totalGuests.toString()
          ),
          subtitle: "Guests",
          link: "Total ",
        },
        {
          key: "available-rooms",
          color: "#FEF1DC",
          iconBg: "#FDE7C6",
          icon: <UnlockOutlined />,
          title: isRoomsLoading ? (
            <Spin size="small" />
          ) : (
            availableRooms.toString()
          ),
          subtitle: "Available Rooms",
          link: "Total ",
        },
        {
          key: "occupied-rooms",
          color: "#DDEEFF",
          iconBg: "#D2E6FD",
          icon: <LockOutlined />,
          title: isRoomsLoading ? (
            <Spin size="small" />
          ) : (
            occupiedRooms.toString()
          ),
          subtitle: "Occupied Rooms",
          link: "Total",
        },
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className={s.wrap}>
      <div className={s.header}>
        <div>
          <div className={s.title}>Today’s Report</div>
          <div className={s.sub}>Report Summary</div>
        </div>
        <Button icon={<UploadOutlined />} className={s.exportBtn}>
          Export
        </Button>
      </div>

      <div className={s.grid}>
        {cards.map((c) => (
          <div key={c.key} className={s.card} style={{ background: c.color }}>
            <div className={s.cardTop}>
              <div className={s.icon} style={{ background: c.iconBg }}>
                {c.icon}
              </div>
              <div className={s.texts}>
                <div className={s.kpiValue}>{c.title}</div>
                <div className={s.kpiTitle}>{c.subtitle}</div>
              </div>
            </div>

            <button type="button" className={s.linkFull}>
              {c.link}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
